<div>
  <frontend-redirect-to-app></frontend-redirect-to-app>
</div>
